export const BAU_COMPLEMENTS_QUERY_KEY = "bau-complements";
export const BAU_COMPLEMENTS_UNIT_QUERY_VALUE = "unit";

export const BAU_FORM_ANSWERS_PATH = "/operational_security/form-answers-bau";

export const hasBauComplementsQueryFlag = (query = {}) =>
  Object.prototype.hasOwnProperty.call(query, BAU_COMPLEMENTS_QUERY_KEY);

export const hasBauComplementsUnitQueryValue = (query = {}) =>
  query?.[BAU_COMPLEMENTS_QUERY_KEY] === BAU_COMPLEMENTS_UNIT_QUERY_VALUE;

export const shouldSendBauAnswersVisitFilter = (route) => {
  if (!route?.path || route.path !== BAU_FORM_ANSWERS_PATH) return false;
  return hasBauComplementsQueryFlag(route.query || {});
};
